import api from './api';

const costReportsService = {
  // Get cost reports data
  getCostReports: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.category) queryParams.append('category', params.category);
      if (params.supplier) queryParams.append('supplier', params.supplier);
      if (params.department) queryParams.append('department', params.department);
      if (params.project) queryParams.append('project', params.project);

      const queryString = queryParams.toString();
      const url = `/cost-reports/reports${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching cost reports:', error);
      throw error;
    }
  },

  // Get filter options
  getCostFilterOptions: async () => {
    try {
      const response = await api.get('/cost-reports/filters');
      return response.data;
    } catch (error) {
      console.error('Error fetching filter options:', error);
      throw error;
    }
  }
};

export default costReportsService;

